// extracted by mini-css-extract-plugin
module.exports = {"___core":"main____core__2rTUL","___coreContent":"main____coreContent__1nfbP"};